<template>
    <div>
        <div class="air__utils__heading">
        <h5>Produtos</h5>
        <a-button type="primary" @click="$router.push('/ecommerce/product/create')">Criar Produto</a-button>
        </div>
        <div class="card">
            <div class="card-body">
                <div v-if="loadingData" style="padding: 10px; padding-top: 20px; padding-bottom: 20px; text-align: center">
                  <a-spin size="large" />
                </div>
                <a-table
                 v-if="!loadingData"
                :columns="columns"
                :dataSource="allProducts"
                :pagination="false"
                :scroll="{ x: '100%' }">
                <template slot="name" slot-scope="text, record">
                  <a href="javascript:" @click="viewProduct(record.id)" style="text-decoration: underline">{{text}}</a>
                </template>
                <template slot="physical" slot-scope="text">
                  {{text == true ? 'Físico':'Digital'}}
                </template>
                <template slot="price" slot-scope="text">
                  <b style="color: #32a852">{{formatMoney(text/100)}}</b>
                </template>
                <template slot="action" slot-scope="text, record">
                    <div class="text-nowrap">
                        <a-tooltip placement="top">
                          <template slot="title">
                            <span>Duplicar</span>
                          </template>
                          <a-button icon="copy" @click="callDuplicateProduct(record.id)"></a-button>
                        </a-tooltip>
                        <a-popconfirm
                        title="Confirmar deletar?"
                        @confirm="confirmDelete(record.id)"
                        @cancel="cancelDelete"
                        okText="Yes"
                        cancelText="No">
                        <a-tooltip placement="top">
                          <template slot="title">
                            <span>Deletar</span>
                          </template>
                          <a-button type="danger" icon="delete"></a-button>
                        </a-tooltip>
                        </a-popconfirm>
                    </div>
                </template>
                </a-table>
            </div>
        </div>

    </div>
</template>

<script>
import { getAllProducts, deleteProduct, duplicateProduct } from '@/services/product'
import store from '@/store'
import { mapGetters } from 'vuex'

const columns = [
  {
    title: 'ID Fiscal',
    dataIndex: 'fiscal_id',
  },
  {
    title: 'Nome',
    dataIndex: 'name',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: 'Tipo',
    dataIndex: 'physical',
    className: 'text-right text-gray-6',
    scopedSlots: { customRender: 'physical' },
  },
  {
    title: 'Preço Unitário',
    dataIndex: 'price',
    className: 'text-right text-gray-6',
    scopedSlots: { customRender: 'price' },
  },
  {
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
  },
]
export default {
  computed: {
    ...mapGetters(['token']),
  },
  data() {
    return {
      columns,
      loadingText: 'Carregando...',
      allProducts: [],
      loadingData: true,
    }
  },
  methods: {
    setLoadingState(state) {
      store.commit('UPDATE_LOADING_STATE', { active: state })
    },
    formatMoney(money) {
      return money.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
    },
    async confirmDelete(productId) {
      this.setLoadingState(true)
      try {
        await deleteProduct(productId, this.token)
        this.reloadOffers()
          .then(data => {
            this.setLoadingState(false)
            this.allProducts = data
            this.$message.success(`Oferta ${productId} deletada!`)
          }).catch(error => {
            console.error('Error on deleting product', error)
            this.setLoadingState(false)
          })
      } catch (error) {
        console.log('Error on delete', error)
      }
    },
    cancelDelete() {
      this.$message.error('Click on No')
    },
    async reloadOffers() {
      return getAllProducts(this.token)
        .then(response => response.data)
    },
    viewProduct(productId) {
      this.$router.push(`/ecommerce/product/${productId}/edit`)
    },
    redirectCreate() {
      this.$router.push('/ecommerce/product/create')
    },
    async callDuplicateProduct(productId) {
      this.setLoadingState(true)
      await duplicateProduct(productId, this.token)
      await this.reloadProducts()
      this.setLoadingState(false)
      this.$message.success(`Oferta ${productId} duplicada!`)
    },
    async editOffer(offerId) {
      console.log('editOffer', { offerId })
    },
    async reloadProducts() {
      return getAllProducts(this.token)
        .then(response => response.data)
        .then(data => {
          this.allProducts = data
          this.setLoadingState(false)
        })
    },
  },
  mounted() {
    getAllProducts(this.token)
      .then(response => response.data)
      .then(data => {
        this.allProducts = data
        this.loadingData = false
        this.setLoadingState(false)
      })
  },
}
</script>
